#import "../../../tasks/graphql/fragments/task-sync.graphql"
#import "../../../calendar/graphql/fragments/calendar-sync.graphql"
#import "../../../email/graphql/fragments/user-email-fragment.graphql"

query GetSyncStatuses {
    loggedInUser {
        id
        personalCalendarFeedUrl
        companyCalendarFeedUrl
        taskSync {
            ...TaskSync
        }
        calendarSync {
            ...CalendarSync
        }
        emailAddresses {
            ...UserEmail
        }
    }
}
